import axios from 'axios';
import {
  clearSelectedCompanyContext,
  getSelectedCompanyId,
} from '../utils/selectedCompany';

const COMPANY_HEADER = 'X-Company-Id';
const COMPANY_CONTEXT_INVALID = 'COMPANY_CONTEXT_INVALID';

let installed = false;

const shouldSkipCompanyContext = (config = {}) => {
  if (config.skipCompanyContext) return true;
  const url = String(config.url || '');
  return /\/auth\/(?:login|signup|session)(?:\?|$)/.test(url)
    || /\/client-portal(?:\/|\?|$)/.test(url);
};

export const buildCompanyContextHeaders = (config = {}, companyId = getSelectedCompanyId()) => {
  if (!companyId || shouldSkipCompanyContext(config)) return config.headers || {};
  return {
    ...(config.headers || {}),
    [COMPANY_HEADER]: String(companyId),
  };
};

export const installCompanyContextInterceptors = () => {
  if (installed || !axios?.interceptors?.request || !axios?.interceptors?.response) return;
  installed = true;

  axios.interceptors.request.use((config) => ({
    ...config,
    headers: buildCompanyContextHeaders(config),
  }));

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const responseCode = error?.response?.data?.code;
      if (Number(error?.response?.status) === 403 && responseCode === COMPANY_CONTEXT_INVALID) {
        clearSelectedCompanyContext();
      }
      return Promise.reject(error);
    }
  );
};

installCompanyContextInterceptors();

export { COMPANY_CONTEXT_INVALID, COMPANY_HEADER };
